module.exports = __webpack_public_path__ + "img/f-2-3.4bc21bbb.png";